export const iconFontAwesomeReligionToriiGate = (
	<i className="fa-solid fa-torii-gate"></i>
);
